import { UtilsService } from '@shared/services/utils/utils.service';
import { Numbers } from 'src/app/utils/constants';
import FormsStepsUtils from '../forms-steps.utils';
import { DerogacionesInterface, ListaAseguradosAdicionalesInterface,
  ListaGarantiasInterface, PresupuestoGuardarInterface, TomadorPresupuestoInterface } from 'src/app/core/interfaces/presupuesto-guardar.interface';
import { Sport } from 'src/app/core/models/sports.model';
import { ProductIdCorreduria } from 'src/app/core/interfaces/producto-informacion.interface';

export default class EmergencyContactUtils extends FormsStepsUtils {
  utilsSrv: UtilsService;

  /**
   * @description constructor
   * @param utilsSrv any
   */
  constructor(utilsSrv: UtilsService) {
    super(utilsSrv);
    this.utilsSrv = utilsSrv;
  }

  /**
   * @description Recupera los códigos de derogación
   */
  getDerogationCodes(formDataValue: any): DerogacionesInterface[] {
    const derCodes: DerogacionesInterface[] = formDataValue.derogationCodes;
    const maped: DerogacionesInterface[] = derCodes.map((el: any) => {
      return {
        codDerogacion: el,
        desDerogacion: ''
      };
    });
    return maped;
  }

  /**
   * @description Recupera los seguros adicionales
   */
  getGarantees(formDataValue: any): ListaGarantiasInterface[] {
    const garantees: any = formDataValue.guaranteeSelectionList;
    let garanteesList: ListaGarantiasInterface[] = [];
    if (garantees.length > 0) {
      garanteesList = garantees.map((el: any) => {
        return {
          ...el,
          Id_Producto: formDataValue.guaranteeLimitOfMedicalExpenses.idProducto,
          idAmbito: formDataValue.countryDestinyEnvironment
        };
      });
    }
    return garanteesList;
  }

  /**
   * @description Recupera el nombre del país de destino
   */
  getCountryDestiny(formData: any, insureSelected: any): string {
    let nameCountry = '';
    const chosed: any = formData.get([insureSelected, 'countryDestiny']).value;
    if (Array.isArray(chosed)) {
      nameCountry = chosed[0].name;
    } else {
      nameCountry = chosed.name;
    }
    return nameCountry;
  }

  /**
   * @description Retorna los datos del tomador y tarjeta
   */
  getTomador(formDataValue: any, isTarjeta: boolean): TomadorPresupuestoInterface[] {
    let auxName: string = formDataValue.insuredData.particular.name;
    if (auxName === '' || auxName === undefined) { auxName = ''; }
    const insuredChoosed: any = formDataValue.insuredData.typeOwner;
    let razonSocial = '';
    let ape1 = '';
    let ape2 = '';
    let countryAux = '';
    const valSocial: any = formDataValue.insuredData.bussines.direction;
    if (insuredChoosed === 'Empresa' && formDataValue.insuredData.documentType.name === 'CIF') {
      razonSocial = valSocial;
      if (valSocial === '' || valSocial === undefined) { razonSocial = ''; }
      ape1 = '';
      ape2 = '';
    } else {
      razonSocial = valSocial;
      if (valSocial === '' || valSocial === undefined) { razonSocial = auxName; }
      ape1 = formDataValue.insuredData.firstSurname;
      ape2 = formDataValue.insuredData.secondSurname;
    }
    let idSector = '';
    if (insuredChoosed === 'Empresa') { idSector = formDataValue.insuredData.bussines.companySector.id; }
    let indCif = 0;
    // 1 NIF => 2 CIF => 3 NIE => 4 pas
    if (formDataValue.insuredData.documentType.name === 'CIF') {
      indCif = 1;
    }
    let cif = '';
    if (formDataValue.insuredData.documentType.name !== 'Pasaporte') { cif = formDataValue.insuredData.documentNumber; }
    let pasaporte = '';
    if (formDataValue.insuredData.documentType.name === 'Pasaporte') { pasaporte = formDataValue.insuredData.documentNumber; }
    if (formDataValue.insuredData.country.name !== undefined) {
      countryAux = formDataValue.insuredData.country.name;
    } else {
      countryAux = formDataValue.insuredData.country;
    }
    const separarPrefijo: any = formDataValue.insuredData.prefix.split('(');
    const prefijo: any = separarPrefijo[1].split(')');
    let typeTpv: number = Numbers.number16;
    if (isTarjeta === true) {
      typeTpv = Numbers.number16;
    } else {
      typeTpv = Numbers.number22;
    }
    const auxVal: TomadorPresupuestoInterface[] = [
      {
        documento: formDataValue.insuredData.documentNumber,
        tipoDocumento: formDataValue.insuredData.documentType.name,
        Id_Presupuesto: 0,
        nombreRazonSocial: razonSocial,
        apellido1: ape1,
        apellido2: ape2,
        direccion: formDataValue.insuredData.direction,
        idMunicipio: formDataValue.insuredData.municipality.id,
        municipio: formDataValue.insuredData.municipality.name,
        telDomicilio: '',
        telMovil: prefijo[0] + formDataValue.insuredData.telephone,
        telTrabajo: '',
        fax: '',
        emailTomador: formDataValue.insuredData.email,
        indDomiciliar: 0,
        idViaPago: typeTpv, // typeTpv
        entidad: '',
        sucursal: '',
        DC: '',
        cuenta: '',
        idCliente: 0,
        iban: '',
        swift: '',
        cp: formDataValue.insuredData.postalCode,
        idProvincia: formDataValue.insuredData.provinceId,
        provincia: formDataValue.insuredData.province,
        pais: countryAux,
        idSector,
        indCif,
        CIF: cif,
        Pasaporte: pasaporte,
        idCcc: 0
      }
    ];

    return auxVal;
  }

  getDescuentoMediador(productosCorreduria: any[], idProducto: number): number {
    if (!(productosCorreduria.length === 1 && productosCorreduria[0] === 0)) {
      return productosCorreduria.filter(item => Number(item.producto) === idProducto)[0].descuentoMediador;
    } else {
      return 0;
    }
  }

  /**
   * @description Generar el presupuesto
   */
  callPresupuestoGuardar(
    formDataValue: any,
    insureSelected: any,
    isTarjeta: boolean,
    productosCorreduria: ProductIdCorreduria[]): PresupuestoGuardarInterface {
    let idProveedorWeb = 1;
    const dateToday: string = this.utilsSrv.getDateToday();
    let auxName: any = formDataValue.insuredData.particular.name;
    if (auxName === '' || auxName === undefined) { auxName = ''; }
    let idIndReceptivo = false;

    if (formDataValue.countryOriginEnvironment !== Numbers.number19001) { idIndReceptivo = true; }
    if (formDataValue.idCorreduria !== '') {
      idProveedorWeb = formDataValue.idCorreduria;
    } else {
      idProveedorWeb = 1;
    }
    const separarPrefijo: any = formDataValue.insuredData.prefix.split('(');
    const prefijo: any = separarPrefijo[1].split(')');
    let mascotas = 0;
    if ( formDataValue.petInsureds && formDataValue.petInsureds.id) {
      mascotas = formDataValue.petInsureds.id;
    }


    const presu: PresupuestoGuardarInterface = {
      idProducto: formDataValue.guaranteeLimitOfMedicalExpenses.idProducto,
      fecEfecto: this.utilsSrv.changeDateOrderToService(formDataValue.dateStart),
      fecVencimiento: this.utilsSrv.changeDateOrderToService(formDataValue.dateEnd),
      listaViajeros: this.addTravelers(formDataValue, insureSelected),
      precioPresupuesto: +formDataValue.insuranceType.price,
      // Id_proveedor: 1,
      idProveedor: idProveedorWeb,
      tomadorPresupuesto: this.getTomador(formDataValue, isTarjeta),
      indCondiciones: 1,
      emNombre: formDataValue.emergencyContact.name,
      emApe1: formDataValue.emergencyContact.firstSurname,
      emApe2: formDataValue.emergencyContact.secondSurname,
      emRelacionAsegurado: formDataValue.emergencyContact.relationWithInsured,
      emTel1: prefijo[0] + formDataValue.emergencyContact.telephone,
      desDescuento: formDataValue.codePromotional,
      listaAseguradosAdicionales: this.getInsuredListAdditional(formDataValue),
      procedencia: 'WEB',
      fecTarificacion: dateToday,
      derogaciones: this.getDerogationCodes(formDataValue),
      descuentoMediador: this.getDescuentoMediador(productosCorreduria, formDataValue.guaranteeLimitOfMedicalExpenses.idProducto),
      nombrePresupuesto: 'Proyecto',
      accion: 0,
      idPresupuestoActualizar: 0,
      viajesPersonales: 0,
      idPortal: 1,
      idComercial: 0,
      garantias: this.getGarantees(formDataValue),
      idModalidad: 1,
      idAmbitoOrigen: formDataValue.countryOriginEnvironment,
      idAmbitoDestino: formDataValue.countryDestinyEnvironment,
      indReceptivo: idIndReceptivo,
      unidadFamiliar: formDataValue.allInsuredSameFamiliarUnit,
      idFraccionamientoPago: 0,
      slCodigoAgencia: '',
      slComision: '',
      slDistrito: '',
      slMonitor: '',
      slNifAuxiliarExterno: '',
      slZona: '',
      idRedProduccion: '',
      origen: formDataValue.countryOrigin.name,
      listadoConsentimientos: [
        {
          idTipoConsentimiento: Numbers.number1,
          aceptacion: parseInt(formDataValue.termsList[Numbers.number0].Aceptacion, Numbers.number10)
        },
        {
          idTipoConsentimiento: Numbers.number9,
          aceptacion: parseInt(formDataValue.termsList[Numbers.number1].Aceptacion, Numbers.number10)
        },
        {
          idTipoConsentimiento: Numbers.number15,
          aceptacion: parseInt(formDataValue.termsList[Numbers.number2].Aceptacion, Numbers.number10)
        },
        {
          idTipoConsentimiento: Numbers.number16,
          aceptacion: parseInt(formDataValue.termsList[Numbers.number3].Aceptacion, Numbers.number10)
        }
      ],
      renta: 0,
      indRenovacionAuto: false,
      idSubtipoPoliza: 1,
      idTipoRenovacionAsegurado: 1,
      indPolizaMarco: false,
      tipoCobertura: this.getCoverageType(formDataValue),
      numOpcionContratacion: Numbers.number2,
      idSobreprima: 0,
      listaPaises: this.getListaPaises(formDataValue, insureSelected),
      deporte: this.getSports(formDataValue, insureSelected),
      AutorizadoFirma: true,
      indRenovableTemporal: false,
      mascotasAseguradas: mascotas
    };

    return presu;
  }

  /**
   * setNumberOfInsuredsOlder
   * @param formDataValue formDataValue
   * @param insureSelected insureSelected
   * @returns returns
   */
  setNumberOfInsuredsOlder(formDataValue: any, insureSelected: any): number {
    let numberOfInsuredsOlder = 0;
    if (insureSelected === 'incomingStudentsTravelAsistance'
      && formDataValue.insuredOlderThan60years
      && formDataValue.insuredOlderThan60years.id
    ) {
      numberOfInsuredsOlder = formDataValue.insuredOlderThan60years.id;
    } else {
      if (formDataValue.insuredOlderThan70years && formDataValue.insuredOlderThan70years.id) {
        numberOfInsuredsOlder = formDataValue.insuredOlderThan70years.id;
      }
    }
    return numberOfInsuredsOlder;
  }

  /**
   * @description Recupera las coberturas
   */
  getCoverageType(formDataValue: any): string {
    const formType: string = formDataValue.insuranceDuration;
    let resCoverage = '';
    if (['form1.duration-temporal', 'form3.duration-temporal', 'Temporal', 'Temporary'].some(el => formType === el)) {
      resCoverage = 'Temporal';
    } else if (['form1.duration-anual', 'form3.duration-anual', 'Anual'].some(el => formType === el)) {
      resCoverage = 'Anual';
    } else if (['form1.duration-long', 'form3.duration-long', 'Larga Estancia', 'Long stay'].some(el => formType === el)) {
      resCoverage = 'Anual_+90';
    } else {
      resCoverage = '';
    }
    return resCoverage;
  }

  /**
   * @description Retorna el listado de países destino seleccionado - paso 1
   */
  getListaPaises(formDataValue: any, insureSelected: string): { idPais: number; desPais: string; }[] {
    let DestinyListAux: { idPais: number, desPais: string};
    let returnV: { idPais: number, desPais: string}[];
    let DestinyL: { name: string, id: number }[];
    const DestinyList: { idPais: number, desPais: string}[] = [];
    const DestinyLAux: any = formDataValue.countryDestiny;

    if (insureSelected === 'incomingStudentsTravelAsistance') {
      const DestinyI: any = formDataValue.countryDestinyI;

      if (DestinyI !== '') {
        DestinyL = [{ name: 'España', id: Numbers.number19001 }];
      } else {
        DestinyL = [DestinyLAux];
      }
    } else if (insureSelected === 'individualTravelAsistance') {
      DestinyL = [{ name: 'España', id: Numbers.number19001 }];
    } else if (DestinyLAux.constructor.toString().indexOf('Array') === -1) {
      DestinyL = [DestinyLAux];
    } else {
      DestinyL = DestinyLAux;
    }

    DestinyL.map((el: { name: string, id: number }) => {
      DestinyListAux = {
        idPais: el.id,
        desPais: el.name
      };
      DestinyList.push(DestinyListAux);
    });
    returnV = DestinyList;

    return returnV;
  }

  /**
   * @description Retorna los deportes - para el formulario de deporte
   */
  getSports(formDataValue: any, insureSelected: string): any[] {
    let returnV: Sport[];
    const auxVal: Sport[] = [];
    if (insureSelected === 'sportTravelAsistance') {
      let SportsListAux: any;
      const SportsList: Sport[] = [];
      const Sports: Sport[] = formDataValue.sports;
      Sports.map((el: Sport) => {
        SportsListAux = {
          ...el,
          idDeporte: el.id,
          idPresupuesto: 0
        };
        SportsList.push(SportsListAux);
      });
      returnV = SportsList;
    } else {
      returnV = auxVal;
    }

    return returnV;
  }

  /**
   * @description Recupera los seguros adicionales
   */
  getInsuredListAdditional(formDataValue: any): ListaAseguradosAdicionalesInterface[] {
    const insuredList: any[] = formDataValue.insuredListData;
    const fillProperties: ListaAseguradosAdicionalesInterface[] = insuredList.map(insured => {
      const obj: ListaAseguradosAdicionalesInterface = {
        idAsegurado: 0,
        nombreAsegurado: insured.name,
        apellido1Asegurado: insured.firstSurname,
        apellido2Asegurado: insured.secondSurname,
        nifAsegurado: insured.documentNumber,
        fechaNacimientoAsegurado: this.utilsSrv.changeDateOrderToService(insured.dateBorn),
        ambitoOrigen: formDataValue.countryOriginEnvironment,
        ambitoDestino: formDataValue.countryDestinyEnvironment,
        tipoCoberturaAsegurado: this.getCoverageType(formDataValue), // Temporal / Anual_+90 / Anual larga estancia
        fecEfecto: this.utilsSrv.changeDateOrderToService(formDataValue.dateStart),
        fecVencimiento: this.utilsSrv.changeDateOrderToService(formDataValue.dateEnd),
        idSobrePrimaAsegurado: this.getPrimaType(insured), // Normal (1) / 70+ (24) / Riesgo (1)
        desDescuento: formDataValue.codePromotional,
        email: insured.email,
        idTipoDescuento: 0,
        fecTarificacion: this.utilsSrv.getDateToday(),
        idPoliza: 0
      };
      return obj;
    });
    return fillProperties;
  }

  /**
   * @description getPrimaType
   * @param data any
   * @returns number
   */
  getPrimaType(data: any): number {
    let res = 0;
    if (data.prima !== undefined) { res = data.prima; }
    return res;
  }

  mapTravelers(data: Record<string , any> ): any {
    return {
      idAsegurado: 0,
      nombreAsegurado: data.name,
      apellido1Asegurado: data.firstSurname,
      apellido2Asegurado: data.secondSurname,
      nifAsegurado: data.documentNumber,
      fechaNacimientoAsegurado: this.utilsSrv.changeDateOrderToService(data.dateBorn),
      ambitoOrigen: data.countryOriginEnvironment,
      ambitoDestino: data.countryDestinyEnvironment,
      tipoCoberturaAsegurado: this.getCoverageType(data), // Temporal / Anual_+90 / Anual larga estancia
      fecEfecto: this.utilsSrv.changeDateOrderToService(data.dateStart),
      fecVencimiento: this.utilsSrv.changeDateOrderToService(data.dateEnd),
      idSobrePrimaAsegurado: this.getPrimaType(data), // Normal (1) / 70+ (24) / Riesgo (1)
      desDescuento: data.codePromotional,
      email: data.email,
      idTipoDescuento: 0,
      fecTarificacion: this.utilsSrv.getDateToday(),
      idPoliza: 0
    };
  }

}
